import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-103e0bd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container store-page py-3" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12 col-lg-7" }
const _hoisted_4 = { class: "border rounded-3 p-4 bg-light-subtle" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "user-id"
}, "游戏 UserID", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "请从服务器个人页面打开带有 ?userid= 的充值链接。", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "amount"
}, "充值金额（人民币）", -1))
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "¥", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "可充值 1.00 至 1000.00 元。", -1))
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Article = _resolveComponent("Article")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Article, {
      headers: "赞助充值",
      texts: "感谢您支持我们的 Minecraft 服务器。充值金额会在支付确认后转发到游戏账户系统。请确认页面中的 UserID 正确，再选择金额完成支付宝支付。"
    }),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("input", {
                id: "user-id",
                class: "form-control",
                value: _ctx.userId || '无法自动获取',
                readonly: ""
              }, null, 8, _hoisted_7),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  id: "amount",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.amount) = $event)),
                  class: "form-control",
                  type: "number",
                  min: "1",
                  max: "1000",
                  step: "0.01",
                  inputmode: "decimal",
                  disabled: _ctx.isBusy,
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.startPayment && _ctx.startPayment(...args)), ["enter"]))
                }, null, 40, _hoisted_13), [
                  [_vModelText, _ctx.amount]
                ])
              ]),
              _hoisted_14
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary w-100",
              type: "button",
              disabled: !_ctx.canPay,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startPayment && _ctx.startPayment(...args)))
            }, _toDisplayString(_ctx.isBusy ? '正在创建订单...' : '使用支付宝支付'), 9, _hoisted_15),
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["alert mt-3 mb-0", _ctx.messageClass]),
                  role: "status"
                }, _toDisplayString(_ctx.message), 3))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}